<template>
  <div id="WaitPay">
    <main class="main-box">
      <div class="main">
        <h3>当前状态</h3>
        <div class="top">
          <div class="left">
            <button>待支付</button>
          </div>
          <div class="right">
            <div>
              请在
              <span style="color: #f7b515;">29:18</span>
              S内完成付款
            </div>
            <br />
            <div style="font-size: 13px;">
              点击这里
              <span>付款</span>
              ；如果您不想购买，可以
              <span>取消订单</span>
            </div>
          </div>
        </div>
        <hr />
        <h3 style="margin-top: 30px;">课程信息</h3>
        <div class="content">
          <img src="#" alt="" />
          <br />
          <p>课程名称课程名称课程名称课程名称课程名称</p>
          <br />
          <br />
          <br />
          <br />
          <p class="price">
            ￥
            <span>100.00</span>
          </p>
        </div>
        <br />
        <br />
        <br />
        <div class="total">
          <p>需支付金额</p>
          <p>
            课程金额
            <span>
              ￥
              <span>100.00</span>
            </span>
          </p>
          <p>
            应付金额
            <span class="color">
              ￥
              <span>100.00</span>
            </span>
          </p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'WaitPay',
};
</script>

<style lang="scss" scoped>
.main-box {
  width: 1200px;
  height: 80vh;
  margin: auto;
  .top {
    display: flex;
    margin-bottom: 30px;
    button {
      width: 200px;
      height: 60px;
      background: transparent;
      border: transparent;
      background: #f7b515;
      outline: none;
      border-radius: 5px;
      color: #ffffff;
      margin: 30px 40px 30px 0;
    }
    .right {
      font-size: 12px;
      margin: 40px 0 20px 0;
    }
  }
  .main {
    height: 80vh;
    padding: 60px 30px;
  }
  .content {
    margin: 30px 0px;
    img {
      width: 400px;
      height: 200px;
      margin-right: 30px;
      float: left;
    }
    .price {
      font-size: 30px;
      color: #f7b515;
    }
  }
}
</style>
